
var BrowserClass = function() {

        try {
            var ua = navigator.userAgent, appName = navigator.appName, browserClassname = '';
            if(appName == 'Netscape' && ua.indexOf("Trident") != -1) {
                // is ie 11
                browserClassname = 'ie11';
                window.isIE = true;
            }
            else {
                browserClassname = (/(Firefox|MSIE|Chrome|Safari|Opera)[\/\s](\d+)/).exec(ua).splice(1, 2).join('').toLowerCase();
                if(browserClassname.indexOf('msie') != -1) window.isIE = true;
            }
            document.getElementsByTagName('body')[0].classList.add(browserClassname);
        } catch (e) {}
        
};


export { BrowserClass };